<template>
      <!-- Begin page -->
      <div id="wrapper">
            
            <!-- Top Bar Start -->
            <topbar></topbar>
            <!-- Top Bar End -->
            
            
            <!-- ========== Left Sidebar Start ========== -->
            
            <!-- Left Sidebar End -->
            <left></left>
      <!-- Begin page -->
      <div class="content-page">
            <!-- Start content -->
            <div class="content">
                  <div class="container-fluid">
                        
                        <div class="row">
                              <div class="col-12">
                                    <div class="page-title-box">
                                          <h4 class="page-title float-left">考试专区</h4>
                                          <ol class="breadcrumb float-right">
                                                <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                <li class="breadcrumb-item"><a href="#">考试专区</a></li>
                                                <li class="breadcrumb-item active">考试报名</li>
                                          </ol>
                                          
                                          <div class="clearfix"></div>
                                    </div>
                              </div>
                        </div>
                        <!-- end row -->
                        
                        
                        <div class="row">
                              <div class="col-12">
                                    <div class="card-box">
                                          <h4 class="m-t-0 header-title" style="border-bottom: 1px solid #868686;padding-bottom: 10px;"><b style="font-size: 16px;margin-bottom: 10px;">请确认个人信息并获取资格码</b></h4>
                                       
                                          
                                          <div class="table-responsive" style="width: 100%">
                                                <table class="table table-bordered table-striped">
                                                     
                                                      <tbody>
                                                      <tr>
                                                            <th class="text-nowrap" scope="row" style="width: 50%;">姓（中文）</th>
                                                            <td>{{surname}}</td>
                                                      </tr>
                                                      <tr>
                                                            <th class="text-nowrap" scope="row">名（中文）</th>
                                                            <td>{{name}}</td>
                                                      </tr>
                                                      <tr>
                                                            <th class="text-nowrap" scope="row">姓（拼音）</th>
                                                            <td>
                                                                  <input v-if="status==4" type="text" name="country"
                                                                       v-model="surname_en"
                                                                       class="form-control">
                                                                  <input v-else-if="status==7" type="text" name="country"
                                                                         v-model="surname_en"
                                                                         class="form-control">
                                                                  <input v-else type="text" name="country"
                                                                         v-model="surname_en"
                                                                         class="form-control" disabled =“disabled”>
                                                            
                                                            </td>
                                                      </tr>
                                                      <tr>
                                                            <th class="text-nowrap" scope="row">名（拼音）</th>
                                                            <td>
                                                                  <input v-if="status==4" type="text" name="country"
                                                                       v-model="name_en"
                                                                       class="form-control">
                                                                  <input v-else-if="status==7" type="text" name="country"
                                                                         v-model="name_en"
                                                                         class="form-control">
                                                                  <input v-else type="text" name="country"
                                                                         v-model="name_en"
                                                                         class="form-control" disabled =“disabled”>
                                                            </td>
                                                      </tr>
                                                      <tr>
                                                            <th class="text-nowrap" scope="row">手机</th>
                                                            <td>{{tel}}</td>
                                                      </tr>
                                                      <tr>
                                                            <th class="text-nowrap" scope="row">邮箱</th>
                                                            <td>{{email}}</td>
                                                      </tr>

                                                      </tbody>
                                                </table>
                                                <div>
                                                      <div style="float: right">
                                                            <button type="submit" class="btn btn-gradient btn-rounded waves-light waves-effect w-md"   v-on:click="edit" v-if="status==4" >个人信息无误，获取资格码</button>
                                                            <button type="submit" class="btn btn-gradient btn-rounded waves-light waves-effect w-md"   v-on:click="edit" v-if="status==7">个人信息无误，获取资格码</button>
                                                      </div>
                                                      
      
                                                      <div class="tishi1" style="float: left;"><img src="4.jpg" style="width: 15px;margin-right: 3px;">请确认/修改您的姓（拼音）、名（拼音），无误后点击获取资格码按钮。</div>
                                                      <div style="clear: both"></div>
                                                      
                                                </div>
                                                
      
                                                
      
                                                <div class="tiaokuan" v-if="codeing==true">
                                                      <p>请不要刷新，正在生成资格码，请耐心等待！</p>
                                                      
                                                </div>
                                                <div class="tiaokuan" v-if="showcode==true">
                                                      <p>您本次的考试预约资格码：</p>
                                                      <p><span>{{code.code}}</span> （考试预约时，需填写资格码）</p>
                                                      <p>各考点考试预约日期为滚动式开放，建议您提前两周左右约考。考试预约网址：</p>
                                                      <p style="font-size:14px;font-weight: bold"><a href="https://proscheduler.prometric.com/" target="_blank" style="color: #4a7cd0">https://proscheduler.prometric.com</a></p>
                                                      <p>请按照<a href="https://dadandao.oss-cn-beijing.aliyuncs.com/uploads/1/%E7%89%B9%E8%AE%B8%E7%A7%81%E4%BA%BA%E8%B4%A2%E5%AF%8C%E7%AE%A1%E7%90%86%E5%B8%88CPWM%C2%AE%E8%AE%A4%E8%AF%81%E8%80%83%E8%AF%95%E9%A2%84%E7%BA%A6%E6%8C%87%E5%BC%95.pdf" target="_blank">《特许私人财富管理师CPWM<sup>&#174;</sup>认证考试预约指引》</a>的提示进行预约操作。</p>
                                                      <p>如在考试预约时遇到问题，请致电呼叫中心解决：400-613-7050。</p>
                                                </div>
                                                
                                                
                                                
                                                
                                          </div>
      
                                          
                                          <div style="clear: both"></div>
                                          
                                    </div>
                              </div>
                        </div>
                        <!-- end row -->
                  
                  
                  </div> <!-- container -->
            
            </div> <!-- content -->
      
            <!--footer-->
      
      </div>
      
      <!-- END wrapper -->
      </div>

</template>

<script>
      import topbar from './topbar';
      import left from './left';
      export default {
            name: 'main',
            components:{topbar,left},
            data() {
                  return {
                        tel: this.tel,
                        email:this.email,
                        lisname:this.lisname,

                        surname: this.surname,
                        name: this.name,
                        surname_en: this.surname_en,
                        name_en: this.name_en,
                        sex: this.sex,
                        Headquarters: this.Headquarters,
                        BranchOffice: this.BranchOffice,
                        WorkDepartment: this.WorkDepartment,
                        Jobduties: this.Jobduties,
                        address: this.address,
                        
                        
                        
                        showcode:false,
                        
                        code:this.code,
                        codeing:false,
                        
                        status:this.status,
                  }
            },
            mounted(){
                  this.showmember();
            },
            methods: {
                  showmember: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/member_show',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              this.tel=response.data.user.tel;
                              this.email=response.data.user.email;
                              this.lisname=response.data.user.name;

                              this.surname=response.data.information.surname;
                              this.name=response.data.information.name;
                              this.surname_en=response.data.information.surname_en;
                              this.name_en=response.data.information.name_en;
                              this.sex=response.data.information.sex;
                              this.Headquarters=response.data.information.Headquarters;
                              this.BranchOffice=response.data.information.BranchOffice;
                              this.WorkDepartment=response.data.information.WorkDepartment;
                              this.Jobduties=response.data.information.Jobduties;
                              this.address=response.data.information.address;
                              /*
                              this.surname=response.data.information.surname;
                              this.name=response.data.information.name;
                              this.surname_en=response.data.information.surname_en;
                              this.name_en=response.data.information.name_en;
                              this.tel=response.data.user.tel;
                              this.email=response.data.user.email;
                              */
                              this.status=response.data.other.status;
                              
                              //资格码状态
                              this.code=response.data.code;
                              if(this.code!=null && this.status!=7){
                                    this.showcode=true;
                              }
                              
                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  edit:function () {
                        let data = {
                              tel: this.tel,

                              surname: this.surname,
                              name: this.name,
                              surname_en: this.surname_en,
                              name_en: this.name_en,
                              sex: this.sex,
                              Headquarters: this.Headquarters,
                              BranchOffice: this.BranchOffice,
                              WorkDepartment: this.WorkDepartment,
                              Jobduties: this.Jobduties,
                              address: this.address,
                        }
                        this.$axios({
                              method: 'post',
                              url: '/api/member2/member_edit',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if(response.data.code==0){
                                    /*
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'success',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                                    
                                     */
                                    this.request_code();
                              }else{
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'error',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }
                              console.log(response.data.code);

                        }.bind(this)).catch(function OnError() {

                        })
                  },
                  request_code: function () {
                        this.codeing=true;
                        this.$axios({
                              method: 'post',
                              url: '/api/member2/send_code',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if(response.data.code!=1){
                                    //false
                                    swal(
                                          {
                                                title: '异常，请稍后在试，或者联系管理员--'+response.data.msg,
                                                text: '',
                                                type: 'error',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }else{
                                    //success
                                    this.showcode=true;
                                    this.codeing=false;
                                    this.showmember();
                              }
                              
                              
                        }.bind(this)).catch(function OnError() {

                        })

                  },
                 
                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}
      .tiaokuan{width:100%;border:1px dashed #333333;border-radius: 20px;padding:30px;margin:30px 0;}
      .tiaokuan h2{width:100%;text-align: center;font-size:27px;}
      .tiaokuan p{width:100%;font-size:15px;line-height: 28px;}
      .tiaokuan span{font-size:20px;font-weight: bold;}

      .tishi1{color:#477ed1;}
     
</style>



// WEBPACK FOOTER //
// src/components/signup_code.vue